// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually
import React from 'react';

const IconPencil = (props: React.SVGProps<SVGElement>) =>
  /*#__PURE__*/ React.createElement(
    'svg',
    {
      width: '18',
      height: '18',
      viewBox: '0 0 18 18',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
      ...props
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M12.024 2.517 3.15 11.7 1.8 16.2l4.5-1.35 9.184-8.873a2.447 2.447 0 0 0-3.46-3.46z',
      fill: '#fff'
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm3.6 11.7 3.15 2.7m-3.6-2.7 8.874-9.183a2.447 2.447 0 1 1 3.46 3.46L6.3 14.85 1.8 16.2l1.35-4.5z',
      stroke: 'current',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    })
  );

export { IconPencil };
